export default __webpack_public_path__ + "media/backgroundweb.cb227225.jpeg";